import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import SignUp from "./pages/Authentication/Signup/Signup";
import Login from "./pages/Authentication/Login/Login";
import ForgotPassword from "./pages/Authentication/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/Authentication/ResetPassword/ResetPassword";
import Verification from "./pages/Authentication/Verification/Verification";
import VerifyAccount from "./pages/Authentication/Signup/VerifyAccount";
import ValidateResetPassword from "./pages/Authentication/ForgotPassword/ValidateResetPassword";

import DefaultLayout from "./layouts/DefaultLayout";
import Dashboard from "./pages/Dashboard/Dashboard";
import Campaigns from "./pages/Campaigns/Campaigns";
import CreateCampaign from "./pages/Campaigns/CreateCampaign/CreateCampaign";
import EditCampaign from "./pages/Campaigns/EditCampaign";
import ViewCampaign from "./pages/Campaigns/ViewCampaign/ViewCampaign";
import Advertisers from "./pages/Advertisers/Advertisers";
import CreateAdvertisers from "./pages/Advertisers/CreateAdvertisers/CreateAdvertisers";
import EditAdvertisers from "./pages/Advertisers/EditAdvertisers";
import ViewAdvertisers from "./pages/Advertisers/ViewAdvertisers/ViewAdvertisers";
import Publishers from "./pages/Publishers/Publishers";
import CreatePublishers from "./pages/Publishers/CreatePublishers/CreatePublishers";
import EditPublishers from "./pages/Publishers/EditPublishers";
import ViewPublishers from "./pages/Publishers/ViewPublishers/ViewPublishers";
import Billing from "./pages/Billing/Billing";
import Postback from "./pages/Postback/Postback";
import Profile from "./pages/Profile/Profile";
import CreateMembers from "./pages/Profile/CreateMembers/CreateMembers";
import EditMembers from "./pages/Profile/EditMembers";
import Report from "./pages/Report/Report";
import CampaignPublishers from "./components/ReportComponents/CampaignPublishers";
import PublisherCampaigns from "./components/ReportComponents/PublisherCampaigns";
import PublisherLink from "./pages/Publishers/PublisherLink";
import CampaignLink from "./pages/Campaigns/CampaignLink";
import CampaignDetails from "./components/ReportComponents/CampaignDetails";
import PublisherDetails from "./components/ReportComponents/PublisherDetails";

const AppRoutes = () => {
  const { accessToken } = useSelector((state) => state.auth);
  //console.log(accessToken)
  return (
    <>
      <Router>
        <Routes>
          {/* Authentication */}
          <Route
            path="/login"
            element={!accessToken ? <Login /> : <Navigate to="/" />}
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/verify-reset-password"
            element={<ValidateResetPassword />}
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/signup" element={<SignUp />} />
          <Route
            path="/verification-notifier/:email"
            element={<Verification />}
          />
          <Route path="/verify-email" element={<VerifyAccount />} />
          {/* Pages */}
          {/* <Route exact path='/' element={<DefaultLayout />} > */}

          <Route
            path="/"
            element={accessToken ? <DefaultLayout /> : <Navigate to="/login" />}
          >
            <Route index element={<Dashboard />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/create-campaign" element={<CreateCampaign />} />
            <Route
              path="/edit-campaign/:campaignId"
              element={<EditCampaign />}
            />
            <Route
              path="/view-campaign/:campaignId"
              element={<ViewCampaign />}
            />
            <Route path="/advertisers" element={<Advertisers />} />
            <Route path="/create-advertiser" element={<CreateAdvertisers />} />
            <Route
              path="/edit-advertiser/:advertiserId"
              element={<EditAdvertisers />}
            />
            <Route
              path="/view-advertiser/:advertiserId"
              element={<ViewAdvertisers />}
            />
            <Route path="/publishers" element={<Publishers />} />
            <Route path="/create-publisher" element={<CreatePublishers />} />
            <Route
              path="/edit-publisher/:publisherId"
              element={<EditPublishers />}
            />
            <Route
              path="/view-publisher/:publisherId"
              element={<ViewPublishers />}
            />
            <Route path="/billing" element={<Billing />} />
            <Route path="/postback" element={<Postback />} />
            <Route path="/reports" element={<Report />} />
            <Route path="/create-member" element={<CreateMembers />} />
            <Route
              path="/edit-member/:memberId"
              element={<EditMembers />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route
              path="/campaign-publishers/:campaignReference"
              element={<CampaignPublishers />}
            />
            <Route
              path="/publisher-campaigns/:publisherReference"
              element={<PublisherCampaigns />}
            />
            <Route path="/publisher-link/:publisherId" element={<PublisherLink />} />
            <Route path="/campaign-link/:campaignId" element={<CampaignLink />} />
            <Route
              path="/campaign-details/:campaignReference"
              element={<CampaignDetails />}
            />
            <Route
              path="/publisher-details/:publisherReference"
              element={<PublisherDetails />}
            />
          </Route>
        </Routes>
      </Router>
    </>
  );
};

export default AppRoutes;
